import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/buttons/buttons";

export default function Display() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "system";
  });

  const [selectedOption, setSelectedOption] = useState(() => {
    return localStorage.getItem("theme") || "system";
  });

  useEffect(() => {
    const applyTheme = (themeValue) => {
      if (themeValue === "system") {
        // Check system preference
        const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

        if (systemPrefersDark) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      } else if (themeValue === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    // Apply theme immediately
    applyTheme(theme);

    // Save theme preference in localStorage
    localStorage.setItem("theme", theme);

    // Listen for system theme changes when using system default
    if (theme === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleChange = () => applyTheme("system");
      mediaQuery.addEventListener("change", handleChange);

      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [theme]);


  const toggleTheme = (theme) => {
    setTheme(theme);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSubmit = () => {
    toggleTheme(selectedOption);
  };

  return (
    <div data-test="">
      <div className="sm:w-[820px] w-full mt-10 sm:ml-10 sm:mt-0 px-6 pb-10 bg-white dark:bg-[#121212] sm:min-h-[1000px] rounded-sm shadow-lg">
        <div className="border-b-2 py-4 sm:py-6 mb-6 flex sm:block justify-between items-center">
          <p className="text-base font-medium text-gray-800 dark:text-white text-center">
            Display
          </p>
        </div>

        <div className="justify-center items-center mx-auto w-full">
          <div className="mt-2 flex flex-col items-center justify-between gap-3 space-y-2">
            {/* Option 1 */}
            <div className="flex w-full bg-white dark:bg-[#010101] items-center gap-5 px-2 sm:px-8 py-2 sm:py-4 rounded-lg shadow-[-7px_8px_50px_0px_#0000000A,7px_8px_50px_0px_#0000000A]">
              <label className="text-sm mb-2 flex items-center justify-between w-full gap-3">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <p className="text-[#151515] dark:text-white text-lg font-bold">
                      Dark Theme
                    </p>
                    {selectedOption === "dark" && <span className="text-primary bg-[#FFCFD0] text-xs py-1 px-2 rounded-md">
                      Default
                    </span>}
                  </div>

                  <p className="text-sm font-medium">
                    Use a darker interface with black and gray backgrounds for
                    reduced eye strain.
                  </p>
                </div>
                <input
                  type="radio"
                  value="dark"
                  checked={selectedOption === "dark"}
                  onChange={handleOptionChange}
                  className="form-radio text-blue-600"
                />
              </label>
            </div>

            {/* Option 2 */}
            <div className="flex w-full bg-white dark:bg-[#010101] items-center gap-5 px-2 sm:px-8 py-2 sm:py-4 rounded-lg shadow-[-7px_8px_50px_0px_#0000000A,7px_8px_50px_0px_#0000000A]">
              <label className="text-sm mb-2 flex items-center justify-between w-full gap-3">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <p className="text-[#151515] dark:text-white text-lg font-bold">
                      Light Theme
                    </p>
                    {selectedOption === "light" && <span className="text-primary bg-[#FFCFD0] text-xs py-1 px-2 rounded-md">
                      Default
                    </span>}
                  </div>
                  <p className="text-sm font-medium">
                    Use a bright, light-colored interface with white
                    backgrounds.
                  </p>
                </div>
                <input
                  type="radio"
                  value="light"
                  checked={selectedOption === "light"}
                  onChange={handleOptionChange}
                  className="form-radio text-blue-600"
                />
              </label>
            </div>

            {/* Option 3 */}
            <div className="flex w-full bg-white dark:bg-[#010101] items-center mb-4 sm:mb-6 gap-5 px-2 sm:px-8 py-2 sm:py-4 rounded-lg shadow-[-7px_8px_50px_0px_#0000000A,7px_8px_50px_0px_#0000000A]">
              <label className="text-sm mb-2 flex items-center justify-between w-full gap-3">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <p className="text-[#151515] dark:text-white text-lg font-bold">
                      System Default
                    </p>
                    {selectedOption === "system" && <span className="text-primary bg-[#FFCFD0] text-xs py-1 px-2 rounded-md">
                      Default
                    </span>}
                  </div>

                  <p className="text-sm font-medium">
                    Automatically match the app's appearance to your device's
                    system theme.
                  </p>
                </div>
                <input
                  type="radio"
                  value="system"
                  checked={selectedOption === "system"}
                  onChange={handleOptionChange}
                  className="form-radio text-blue-600"
                />
              </label>
            </div>
          </div>

          <div className="mt-10">
            <button
              onClick={() => {
                handleSubmit();
              }}
              className=" mt-5 w-full inline-flex justify-center h-12 rounded-md border border-transparent shadow-sm px-4 py-4 bg-primary text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500  sm:mt-6 sm:text-sm"
            >
              Apply Display
            </button>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <Button.Secondary
          type="button"
          title={"Back"}
          className={"sm:hidden rounded-md mb-8 sm:mb-0 w-full"}
          onClick={() => navigate("/profile")}
        />
      </div>

    </div>
  );
}
